<template>
  <Hero v-if="(creditScoreGrade || getUsCreditScore) && defaultHeroTitle" :title="defaultHeroTitle"></Hero>
  <Hero v-else-if="isByPostalCode" :title="postalCodeTitle"></Hero>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Hero from '../../Hero.vue';

export default {
  name: 'CreditScore',
  components: {
    Hero,
  },
  computed: {
    ...mapGetters('credit', ['creditScoreGrade', 'regionalCreditScoreGrade']),
    ...mapGetters('usCredit', ['getUsCreditScore']),
    ...mapGetters('business', ['displayEquifaxBranding']),
    ...mapState({
      defaultCreditDataSourceCA: state => state.business.info.creditSettings.defaultCreditDataSourceCA,
      preQualificationEnabled: state => state.business.info.creditSettings.prequalificationEnabled,
      consumerInventoryMatchingEnabled: state =>
        state.business.info.creditSettings.prequalificationConsumerInventoryMatchingEnabled,
    }),
    isByPostalCode() {
      return !!this.regionalCreditScoreGrade;
    },
    isEquifaxEnabled() {
      return this.defaultCreditDataSourceCA === this.enums.CreditDataSourceCA.EQUIFAX;
    },
    isCreditPlusEnabled() {
      return this.defaultCreditDataSourceCA === this.enums.CreditDataSourceCA.CREDIT_PLUS;
    },
    postalCodeTitle() {
      // do not display regional title if just Equifax
      if (this.displayEquifaxBranding && !this.preQualificationEnabled) {
        return this.$t('message.hero.creditScoreTitle');
      }
      return this.isEquifaxEnabled || this.isCreditPlusEnabled
        ? this.$t('message.hero.regionalCreditScoreTitle2')
        : this.$t('message.hero.regionalCreditScoreTitle');
    },
    defaultHeroTitle() {
      if (this.preQualificationEnabled) {
        return this.consumerInventoryMatchingEnabled
          ? null
          : this.$t('message.credit.application.preQualification.creditReportTitle');
      }
      return this.$t('message.hero.creditScoreTitle');
    },
  },
};
</script>

<style scoped></style>
